'use strict';

var React = require('react');

var SvgFormsMajor = function SvgFormsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 4.5a.75.75 0 0 1 0 1.5c-.906 0-1.412.17-1.665.296-.032.016-.06.031-.085.046v7.343a.86.86 0 0 0 .068.034c.257.12.77.281 1.682.281a.75.75 0 0 1 0 1.5c-1.088 0-1.825-.191-2.318-.422a2.972 2.972 0 0 1-.182-.093 2.972 2.972 0 0 1-.182.093c-.493.23-1.23.422-2.318.422a.75.75 0 0 1 0-1.5c.912 0 1.425-.16 1.682-.28l.068-.035v-7.343a1.447 1.447 0 0 0-.085-.046c-.253-.127-.76-.296-1.665-.296a.75.75 0 0 1 0-1.5c1.094 0 1.838.205 2.335.454.059.03.114.06.165.089.051-.03.106-.06.165-.089.497-.248 1.24-.454 2.335-.454Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.25c0-.69.56-1.25 1.25-1.25h3.25a.75.75 0 0 0 0-1.5h-3.25a2.75 2.75 0 0 0-2.75 2.75v1.5a2.75 2.75 0 0 0 2.75 2.75h3.25a.75.75 0 0 0 0-1.5h-3.25c-.69 0-1.25-.56-1.25-1.25v-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 6.5a.75.75 0 0 0 0 1.5h.125c.69 0 1.25.56 1.25 1.25v1.5c0 .69-.56 1.25-1.25 1.25h-.125a.75.75 0 0 0 0 1.5h.125a2.75 2.75 0 0 0 2.75-2.75v-1.5a2.75 2.75 0 0 0-2.75-2.75h-.125Z"
  }));
};
SvgFormsMajor.displayName = "FormsMajor";

exports.SvgFormsMajor = SvgFormsMajor;
